export default __webpack_public_path__ + "static/nestery-298a2f4374d1422514d85d7637a39fdf.webp";